import API from './API';

/** Il messaggio di un errore del server, se leggibile. */
export const serverMessage = (e) => {
  const msg = e?.response?.data?.message;
  return Array.isArray(msg) ? msg.join(', ') : (typeof msg === 'string' ? msg : '');
};


export default {

  getCarsByCustomer(customerId, /* partnerId */) {
    return API.get(`/car?filter=customer.id||$eq||${customerId}&` , {
      params: {
       join: 
       [
         'minutes',
         'minutes.partner',
         'customer',
         'headquarters',
         'headquarters.employees'
       ]
       
     },  
   });
  },

  addCar(car){
    return API.post('/car/create', car)
  },

  // Con `valet_band_id` il server ricalcola i prezzi e può rispondere 400
  // (pickup/anno, mesi, fascia di un altro partner, prezzo mancante…) con un
  // messaggio leggibile: le pagine lo mostrano da sé con { skipErrorToast }.
  addMinute(minute, config = {}){
    return API.post(`/minute` , minute, config);
  },

  // Manda al cliente l'email con il link per confermare il pacchetto valet.
  // In errore il backend risponde 200 con `stato: 'reject'`: va letto il corpo.
  mailAddMinute(id) {
    return API.get(`/minute/new/${id}`);
  },

  // Conferma del pacchetto valet da parte di Simba, al posto del cliente.
  // È la STESSA rotta del link nell'email (pubblica): segna `accepted`, crea
  // la provvigione del partner e manda le email di avvenuta conferma. Non
  // usare PATCH /minute con accepted:true, che salterebbe provvigione ed
  // email. In errore risponde 200 con `stato: 'reject'`: va letto il corpo.
  confirmMinute(id) {
    return API.get(`/minute/confirm/${id}`);
  },

  getCarByTarga(targa){
    return API.get(`/car?filter=targa||$eq||${targa}` );
  },
}